<div class="btn-group" dropdown container="body" *ngIf="visibleItems.length">
  <button
    type="button"
    class="btn btn-outline-secondary btn-sm"
    dropdownToggle>
    <i class="bx {{icon}} me-1"></i>{{label|translate}}
  </button>
  <ul *dropdownMenu class="dropdown-menu dropdown-menu-end">
    <li *ngFor="let item of visibleItems">
      <button
        type="button"
        class="dropdown-item d-flex align-items-center"
        [class.disabled]="item.disabled"
        [disabled]="item.disabled"
        (click)="onItemClick(item)">
        <i *ngIf="item.icon" class="bx {{item.icon}} me-2" [ngClass]="item.color ? 'text-' + item.color : ''"></i>
        <span>{{item.label|translate}}</span>
      </button>
    </li>
  </ul>
</div>
